import React, { useEffect, useRef, useState } from "react";
import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { IColumn, ICommandBarItemProps, Icon, Stack, TooltipHost, mergeStyleSets } from "@fluentui/react";
import { TableBase2 } from "../../../../components/Table/TableBase2";
import { PaginationFooterC } from "../../../../components/PaginationFooter/PaginationFooterC";
import IconHelper from "../../../../utils/helpers/iconHelper";
import ActividadService from "../../../../services/Iperc/ActividadService";
import { IActualizarActividad, IDataTableActividades, ITableFIlterIpercActividades, InitialFilterIpercActividades } from "../../../../Interfaces/IPERC/IActividad";
import { IPaginacion } from "../../../../Interfaces/filter";
import { useBoolean } from "@fluentui/react-hooks";
import { PanelCrearActividad } from "./PanelCrearActividad";
import { PanelActualizarActividad } from "./PanelActualizarActividad";
const classNames = mergeStyleSets({
  iconFont: {
    padding: 0,
    fontSize: "16px",
    marginRight: 5,
  },
});

export const ConfiguracionActividadesIperc = () => {

  const [
    isOpenPanelEditActividad,
    { setTrue: openPanelEditActividad, setFalse: onDismissPanelEditActividad },
  ] = useBoolean(false);
  const [isOPenPanel, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);

  const [modelActualizarActividad, setModelActualizarActividad] =
    useState<IActualizarActividad>({
      actividadId: "",
      nombre: ""
    });

  const _itemsLeft: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_ADD,
      onClick: () => {
        openPanel();
      },
    },
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => {
        onClickRefresh();
      },
    },
  ];
  const column: IColumn[] = [
    {
      key: "nombre",
      name: "Actividades",
      fieldName: "nombre",
      minWidth: 150,
      maxWidth: 350,
      isResizable: true,
    },
    // {
    //   key: "equipo",
    //   name: "Equipo",
    //   fieldName: "equipo",
    //   minWidth: 300,
    //   maxWidth: 300,
    //   isResizable: true,
    // },
    {
      key: "created",
      name: "Fecha de creación",
      fieldName: "created",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "opciones",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
      isCollapsible: true,
      data: "number",
      onRender: (item) => (
        <>
          <TooltipHost content={"Editar"}>
            <Icon
              iconName="edit"
              className={classNames.iconFont}
              style={{ cursor: "pointer", color: "black" }}
              onClick={() => {
                setModelActualizarActividad({
                  ...modelActualizarActividad,
                  actividadId: item.actividadId,
                  nombre: item.nombre
                });
                openPanelEditActividad();
              }}
            />
          </TooltipHost>
        </>
      ),
    },
  ];


  const [loading, setLoading] = useState(false);
  const [dataTeble, setDataTeble] = useState<IDataTableActividades[]>([]);
  const [paginacion, setPaginacion] = useState<IPaginacion>(null!);
  const [filter, setFilter] = useState<ITableFIlterIpercActividades>(
    InitialFilterIpercActividades
  );
  const controllerRef = useRef<AbortController>(new AbortController());
  const onChangeSkip = (evento: string) => {
    switch (evento) {
      case "next":
        setFilter({ ...filter, skip: filter.skip + 1 });
        break;
      case "prev":
        setFilter({ ...filter, skip: filter.skip - 1 });
        break;
      default:
        break;
    }
  };
  // const searchBoxRefTable = useRef<ISearchBox>(null);
  const _onkeyUpSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };

  const postDataTableIpercEquipo = () => {
    controllerRef.current?.abort();
    const newAbortController = new AbortController();
    controllerRef.current = newAbortController;
    ActividadService.postTableActividades(newAbortController).then(
      (res) => {
        if (res.status === 200) {
          setLoading(false);
          setDataTeble(res.data);
          // setPaginacion({
          //   page: res.data.page,
          //   total: res.data.total,
          //   pages: res.data.pages,
          // });
        }
      }
    );
  };
  const onClickRefresh = () => {
    if (filter.search !== "") {
      setFilter(InitialFilterIpercActividades);
    } else {
      postDataTableIpercEquipo();
    }
  };
  useEffect(() => {
    postDataTableIpercEquipo();
  }, [filter]);


  return (
    <>
      <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg12">
          <CabeceraTable
            // placeholder="Buscar Por Nombre"
            Titulo="Actividades"
            SubTitulo="Gestión de Actividades"
          // componentRef={searchBoxRefTable}
          // onKeyUp={_onkeyUpSearch}
          />
        </div>
      </div>
      <br />
      <Stack>
        <TableBase2
          leftBar={_itemsLeft}
          data={dataTeble}
          column={column}
          isLoading={false}
          footerPagination={
            <PaginationFooterC
              paginacion={{ page: 0, pages: 0, total: 0 }}
              onChangePagina={(e) => {
                //onChangeSkip(e);
              }}
            />
          }
        />
      </Stack>

      <PanelCrearActividad
        isOpen={isOPenPanel}
        onDismiss={dismissPanel}
        onRefreshTable={onClickRefresh}
      />
      <PanelActualizarActividad
        isOpen={isOpenPanelEditActividad}
        onDismiss={onDismissPanelEditActividad}
        modelActualizarActividad={modelActualizarActividad}
        onRefreshTable={onClickRefresh}
      />
    </>
  );
};
